import {Component, OnInit, Pipe, PipeTransform} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import * as moment from 'moment';
declare let M: any;

interface Client {
  name: string;
  env: Array<object>;
  all_issues: any;
  latest_issue: any;
  mantis_id: number;
  alert_flag: boolean;
}

interface Env {
  name: string;
  type: string;
  url: string;
  url_params_jenkins: Array<string>;
  status: any;
  time_last_build: any;
}

interface HttpCurl {
  certinfo: Array<string>;
  connect_time: number;
  content_type: string;
  download_content_length: number;
  filetime: number;
  header_size: number;
  http_code: number;
  http_string?: string;
  local_ip: string;
  local_port: number;
  namelookup_time: number;
  pretransfer_time: number;
  primary_ip: string;
  primary_port: number;
  redirect_count: number;
  redirect_time: number;
  redirect_url: string;
  request_size: number;
  size_download: number;
  size_upload: number;
  speed_download: number;
  speed_upload: number;
  ssl_verify_result: number;
  starttransfer_time: number;
  total_time: number;
  upload_content_length: number;
  url: string;
}

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  /**
   * time in ms
   */
  timeout = 30;
  token_mantis = 'HPQ87x2p3O7s_Q_FA1XuGPc-xolFimRu';
  allIssues: any;
  arrPixBroadcast: any;
  lastSentNotification;
  nowTime;
  nowDate;
  isLunchTime;
  listDeploy: Array<any> = [];
  branchesType = [null, "Produção", "Homologação"];

  arrClient: Array<object> = [
    /*{
      name: 'ANTT',
      mantis_id: 1,
      env: [
        {
          name: 'Homologação',
          type: 'intern',
          url: 'http://antt-hmg.hmg.pix.com.br/externo',
          url_params_jenkins: ['Deploy', 'Homolog'],
          status: {}
        },
        {
          name: 'Master',
          type: 'intern',
          url: 'http://antt-master.hmg.pix.com.br/externo',
          url_params_jenkins: ['Deploy', 'Master'],
          status: {}
        },
        {
          name: 'Homologação (Cliente)',
          type: 'extern',
          url: 'http://intra-hml.antt.gov.br/externo',
          url_params_jenkins: ['Package', 'Homolog'],
          status: {}
        },
        {
          name: 'Master (Cliente)',
          type: 'extern',
          url: 'http://intra.antt.gov.br/externo',
          url_params_jenkins: ['Package', 'Master'],
          status: {},
        }
      ]
    },*/
    {
      name: 'Collab',
      mantis_id: 7,
      env: [
        {
          name: 'Homologação',
          type: 'intern',
          url: 'https://hmg.collab.pix.com.br/Collab/login',
          url_params_jenkins: ['Deploy', 'Homolog'],
          status: {}
        },
        {
          name: 'Master',
          type: 'extern',
          url: 'https://collab.pix.com.br/Collab/login',
          url_params_jenkins: ['Deploy', 'Master'],
          status: {},
        },
        {
          name: 'Wali',
          type: 'extern',
          url: 'https://wali.pix.com.br/',
          url_params_jenkins: ['Deploy', 'Wali'],
          status: {},
        },
      ]
    },
    /*{
      name: 'MMA',
      mantis_id: 6,
      env: [
        {
          name: 'Homologação',
          type: 'intern',
          url: 'http://mma-hmg.hmg.pix.com.br/',
          url_params_jenkins: ['Deploy', 'Homolog'],
          status: {}
        },
        {
          name: 'Master',
          type: 'intern',
          url: 'http://mma-master.hmg.pix.com.br/',
          url_params_jenkins: ['Deploy', 'Master'],
          status: {},
        },
        {
          name: 'Homologação (Cliente)',
          type: 'extern',
          url: 'http://homolog-biosfera.mma.gov.br/login',
          url_params_jenkins: ['Package', 'Homolog'],
          status: {}
        },
        {
          name: 'Master (Cliente)',
          type: 'extern',
          url: 'http://biosfera.mma.gov.br/login',
          url_params_jenkins: ['Package', 'Master'],
          status: {}
        }
      ]
    },*/
    {
      name: 'Serpro',
      mantis_id: 16,
      env: [
        /*{
          name: 'Development',
          type: 'intern',
          url: 'http://mj.collab.pix.com.br/login',
          url_params_jenkins: ['Deploy', 'Stage'],
          status: {},
        },
        {
          name: 'Homologação',
          type: 'intern',
          url: 'http://hmg.mj.collab.pix.com.br/login',
          url_params_jenkins: ['Deploy', 'Homolog'],
          status: {}
        },*/
        {
          name: 'Master',
          type: 'intern',
          url: 'http://mj.collab.pix.com.br/login',
          url_params_jenkins: ['Deploy', 'Master'],
          status: {},
        },
        // {
        //   name: 'Pré-produção (Cliente)',
        //   type: 'extern',
        //   url: 'http://pprede.serpro.gov.br',
        //   url_params_jenkins: ['Package', 'Homolog'],
        //   status:{}
        // },
        {
          name: 'Master (Cliente)',
          type: 'extern',
          url: 'http://seguranca.sinesp.gov.br',
          url_params_jenkins: ['Package', 'Master'],
          status: {}
        }
      ]
    },
    {
      name: 'Sebrae',
      mantis_id: 16,
      env: [
        {
          name: 'Homologação',
          type: 'intern',
          url: 'http://hmg.sebrae.collab.pix.com.br/login',
          url_params_jenkins: ['Deploy', 'Homolog'],
          status: {}
        },
        {
          name: 'Master',
          type: 'intern',
          url: 'http://sebrae.collab.pix.com.br/login',
          url_params_jenkins: ['Deploy', 'Master'],
          status: {},
        },
        {
          name: 'Homologação (Cliente)',
          type: 'extern',
          url: 'http://homolog.social.sebrae.com.br/sebrae/login',
          url_params_jenkins: ['Deploy', 'Homolog'],
          status: {}
        },
        {
          name: 'Master (Cliente)',
          type: 'extern',
          url: 'http://conexao.sebrae.com.br',
          url_params_jenkins: ['Package', 'Master'],
          status: {}
        }
      ]
    }
  ];

  constructor(
    private http: HttpClient,
  ) {

  }

  ngOnInit() {
    this.init();
    this.getNowTime();
    this.isLunchTime = (this.nowTime >= '12:00:00' && this.nowTime < '14:00:00') || this.nowTime < '08:45:00' || this.nowTime >= '18:00:00';

    setInterval( () => {
      this.init();
    }, this.timeout * 1000 );

    setInterval( () => {
      this.getNowTime();
      this.getIsLunch();
    }, 900 );
  }

  init() {
    this.arrClient.forEach( ( data: Client ) => {
      data.env.forEach( ( data2: Env ) => {
        this.http.get( 'https://api.adlerluiz.com/curl/?url=' + data2.url )
          .subscribe( ( result: HttpCurl ) => {
            data2.status = result;
            if( data2.type == 'extern' && data2.name == "Master" ) {
              if ( data2.status.http_code != 200 || data2.status.http_code != 403 ) {
                console.log( data.name + ' ' + data2.name + ' está fora do ar')
                const headers = new HttpHeaders({
                  'Content-Type': 'application/json',
                  'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjVjNDljOWY0NWQyMzE1MmNkNDAwNDZjMiIsIm5hbWUiOiJHaXRIdWIifQ.b_0_xKa05t9EgyVU2nAD_tM-3romkkHoxDbjfdejul0'
                });
                /*this.http.post(  'http://broadcast.pix.com.br/v1/notify', {               
                    notification: {
                      title: "Ambiente fora do ar",
                      body: data.name + ' ' + data2.name
                  },
                  created_at: moment().format(),
                  content: '321'
                }, { headers: headers } )
                .subscribe( data => {
                  console.log(data)
                } )*/
              } else {
                console.log(  data.name + ' ' + data2.name + ' OK' )
              }
            }
          } );
        } );
      } );

    this.arrClient.forEach( ( data: Client ) => {
      data.env.forEach( ( data2: Env ) => {
        this.http.get( 'http://ci.collab.pix.com.br/job/' + data.name.toUpperCase() + '/job/' + data2.url_params_jenkins[0]
        + '/job/' + data2.url_params_jenkins[1] + '/lastBuild/api/json')
          .subscribe( ( result ) => {
              console.log(result['timestamp']);
              data2.time_last_build = result['timestamp'];
          } , ( ) => {
              data2.time_last_build = null;
          } );
        } );
      } );

    this.arrClient.forEach( ( data: Client ) => {
      const headers = new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': this.token_mantis
      });

      this.http.get( 'https://mantis.pix.com.br/api/rest/issues?project_id=' + data.mantis_id,  { headers: headers })
        .subscribe( ( result ) => {
            data.alert_flag = false;
            if (data.latest_issue !== undefined) {
                if (data.latest_issue['id'] !== result['issues'][0]['id']) {
                    M.toast({html: 'Novo issue em: ' + data.name, displayLength: 60000, classes: 'red'});
                    data.alert_flag = true;
                }
            }
            data.latest_issue = result['issues'][0];
        } , ( ) => {
          data.latest_issue = null;
        } );
      } );
  
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': this.token_mantis
    });
    this.http.get( 'https://mantis.pix.com.br/api/rest/issues?page_size=10',  { headers: headers })
      .subscribe( ( result ) => {
        this.allIssues = result['issues'];
      } , ( ) => {
        this.allIssues = null;
      } );

    this.getListNextDeploy();
    this.getPixBroadcastData();
  }

  getPixBroadcastData() {
    this.http.get( 'https://broadcast.pix.com.br/v1/notify')
      .subscribe( ( result ) => {
        this.arrPixBroadcast = result;
        // console.log(result)
      } , ( ) => {
        this.arrPixBroadcast = null;
      } );
  }

  getColorStatus( client: Env ) {

    client.status.http_string = ' - ';

    /**
     * Status 200 - OK
     */
    if ( client.status.http_code === 200 || client.status.http_code === 403 ) {
      client.status.http_string = 'OK';
      return ' green ';
    }

    /**
     * Status 503 - Service Unavailable
     */
    if ( client.status.http_code === 503 ) {
      client.status.http_string = 'Serviço Indisponível';
      return ' red blink ';
    }

    /**
     * Status 522 - Connection timed out
     * Status 524 - A timeout occurred
     * Status 0   - Timeout
     */
    if ( client.status.http_code === 522 || client.status.http_code === 524 || client.status.http_code === 0 ) {
      client.status.http_string = 'Timeout na conexão';
      return ' orange ';
    }

    return ' blue ';

  }

  getColorFromCategory( issue ) {

    switch( issue.category.id ) {
      // BUG
      case 3:
        return ' orange ';

      // SLA
      case 4:
        return ' red ';

      // MELHORIA
      case 6:
        return ' green ';
    }

  }

  getBorderColorFromCategory( issue ) {

    switch( issue.category.id ) {
      // BUG
      case 3:
        return ' bug-card ';

      // SLA
      case 4:
        return ' urgent-card ';

      // MELHORIA
      case 6:
        return ' feat-card ';
    }

  }

  getBorderColorFromTypeNotification( notification ) {
    let isUrgent = false;
    notification.metadata.forEach( data => {
      if ( data.name === 'is_urgent' ) {
        isUrgent = data.value;
      }
    });
    if ( isUrgent ) {
      return ' urgent-card ';
    }
  }

  getNowTime() {
    moment.locale('pt-BR');
    this.nowTime = moment().format('HH:mm:ss');
    this.nowDate = moment().format('LL');
  }

  getIsLunch() {
    if (['08:45:00', '12:00:00', '14:00:00', '18:00:00'].includes(this.nowTime)) {
      this.isLunchTime = !this.isLunchTime;
    }

    if (this.nowTime === '08:44:55') {
      new Audio('./assets/rings/SunsSong.mp3').play();
    }
  }

  getListNextDeploy() {
    this.http.get( 'https://xdeploy.hmg.pix.com.br/public/api/external/deploy/all/next')
      .subscribe( ( result: Array<any> ) => {
        this.listDeploy = result;
      } , ( ) => {
        this.listDeploy = null;
      } );
  }

}
